export const SYNC_FAILED = 'touchpoints_sync_has_failed';
export const SYNC_FINISHED = 'touchpoints_sync_has_finished';
export const SYNC_INITIATED = 'touchpoints_sync_was_initiated';
export const TOUCHPOINTS_RESET = 'reset_touchpoints';
export const TOUCHPOINTS_SET = 'set_touchpoints';
export const TOUCHPOINT_GROUPS_SET = 'set_touchpoint_groups';
export const TOUCHPOINT_REMOVE = 'remove_touchpoint';
export const TOUCHPOINT_SET = 'set_touchpoint';
export const TOUCHPOINT_TYPES_SET = 'set_touchpoint_types';
